import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import cx from "classnames";
import { Image } from "semantic-ui-react";
import "./ImageUpload.less";

@observer
class ImageUpload extends Component {
  reader = null;

  constructor(props) {
    super(props);

    this.reader = new FileReader();

    this.state = {
      src: props.defaultSrc,
      hover: false,
      inputStyle: {},
    };
  }

  componentDidUpdate(prevProps) {
    const { defaultSrc } = this.props;
    const { src } = this.state;
    if (defaultSrc !== prevProps.defaultSrc && defaultSrc !== src) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ src: defaultSrc });
    }
  }

  onChange(e) {
    const { accept, onFileSelected } = this.props;
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      // Check if the file type is accepted.
      if (accept.indexOf(file.type) === -1) {
        return;
      }

      this.reader.onload = innerEvent => {
        this.setState({ src: innerEvent.target.result });
        // send the base64 encoded image as well.
        onFileSelected(innerEvent.target.result);
      };

      this.reader.readAsDataURL(file);
    }
  }

  render() {
    const { size, defaultSrc, accept, onFileSelected, ...rest } = this.props;
    const { src, inputStyle, hover } = this.state;

    return (
      <div className={cx("image-upload ui image", { size, hover })}>
        <Image size={size} src={src} {...rest} />
        <input
          onDragEnter={() => this.setState({ hover: true })}
          onDragLeave={() => this.setState({ hover: false })}
          onDrop={() => this.setState({ hover: false })}
          type="file"
          style={inputStyle}
          accept={accept.join(",")}
          onChange={e => this.onChange(e)}
        />
      </div>
    );
  }
}

ImageUpload.propTypes = {
  defaultSrc: PropTypes.string.isRequired,
  size: PropTypes.string,
  accept: PropTypes.array,
  onFileSelected: PropTypes.func.isRequired,
};

ImageUpload.defaultProps = {
  accept: ["image/png", "image/jpeg"],
};

export default ImageUpload;
